import React from "react";
import cx from "classnames";
import UsedcarPopover from "./usedcarPopover";
var NavUsedCar = function NavUsedCar(_ref) {
  var onClick = _ref.onClick,
    active = _ref.active,
    dataSource = _ref.dataSource,
    www = _ref.www,
    auto = _ref.auto,
    ga = _ref.ga,
    ga4 = _ref.ga4,
    uuid = _ref.uuid;
  return /*#__PURE__*/React.createElement("div", {
    id: 'newTopNav1',
    className: cx("tc-top-nav-item", {
      "active-usedcar": active === 1
    })
  }, /*#__PURE__*/React.createElement("a", {
    className: 'tc-top-nav-link',
    href: auto,
    target: '_blank',
    onClick: onClick,
    rel: 'noreferrer'
  }, "\u4E2D\u53E4\u8ECA"), /*#__PURE__*/React.createElement(UsedcarPopover, {
    dataSource: dataSource,
    www: www,
    auto: auto,
    ga: ga,
    ga4: ga4,
    uuid: uuid
  }));
};
export default NavUsedCar;